export default __webpack_public_path__ + "static/media/membership-wave.315ef08a.svg";